import * as React from "react";
import { Row, Col, InputNumber } from "rsuite";
import Pagination from "../../components/common/pagination";
import { headCells } from "./constants";
import Sorting from "../../components/common/sorting";
import { numberFormatter } from '../../utils';
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export class Table extends React.Component<any, any> {
    fontSize = "0.85vw";
    fieldMatchColumns: any = {
        "Product Type": "productType", "Item Type": "itemId", "Cases/year (prior 52 weeks)": "vol",
        "Revenue/year (prior 52 weeks)": "rev", "Loaded Opportunity($)": "opport"
    };
    columnStyle = {
        backgroundColor: "#1a1916", color: "white",
        borderRight: "0.1px solid #333231", borderBottom: "0.1px solid #333231", innerHeight: "36px",
    };

    isFirstTime: boolean = true;
    defaultPageSize: number = 10;
    debounceTimeOutId: any = null;
    debounceTimeOutId1: any = null;

    constructor(props: any) {
        super(props);
        this.state = {
            tableHeight: 250,
            expandedRows: [],
            divExpandedRows: [],
            rowHighlightIndex: null,
            rowHighlightDivIndex: null,
            pageSize: props.pageSize,
            PageNumber: props.pageNumber,
            orderBy: "opportunity",
            order: "desc",
            setOrderForSorting: null,
            pageSizeValue: props.pageSize,
            selectedPC: this.props.selectedPC
        };
    }
    static getDerivedStateFromProps(props: any, state: any) {
        // console.log(props, state);
        if (props.selectedPC !== state.selectedPC) {
            return {
                rowHighlightDivIndex: null,
                rowHighlightIndex: null,
                selectedPC: props.selectedPC,
                divExpandedRows: [],
                expandedRows: []
            };
        }
        return null;
    }

    handleExpansion = (cName: string, customerCheckFlag: boolean = false) => {
        let row = this.state.expandedRows;
        if (row === cName) {
            if (customerCheckFlag && cName !== this.state.rowHighlightIndex) {

            } else {
                row = "";
                this.fontSize = "0.75vw";
            }
        } else {
            row = cName;
            this.fontSize = "0.63vw";
        }
        this.setState({
            divExpandedRows: [],
            expandedRows: row,
            rowHighlightIndex: cName
        });
    }

    handleDivExpansion = (divId: any, cName: any) => {
        let value = cName + "_" + divId;
        let row = this.state.divExpandedRows;
        if (row.includes(value)) {
            row.splice(row.indexOf(value), 1);
        } else {
            row.push(value);
        }
        this.setState({
            divExpandedRows: row,
        });
    }

    handleRowClickLocal = (event: any, index: any, itemId: any = "") => {
        // console.log('Row click Local', event, index, itemId);
        event.customerId = event.id;
        this.handleExpansion(event.id, true);
        this.setState({
            rowHighlightIndex: event.name,
            rowHighlightDivIndex: null
        });
        this.props.handleRowClick(event);
    }

    handleRowClickDiv = (event: any, cName: string, cId: string, dim: boolean = false) => {
        // console.log('Row click Div', event, cName, cId);
        event.name = cName;
        event.customerId = cId;
        if (cName !== this.state.rowHighlightIndex) {
            this.setState({
                rowHighlightIndex: cName
            });
        }
        if (dim) {
            this.setState({
                rowHighlightDivIndex: null,
            });
        }
        else {
            this.setState({
                rowHighlightDivIndex: event.itemId,
            });
        }
        // this.setState({
        //     rowHighlightDivIndex: event.itemId,
        // });
        this.props.handleRowClick(event, false, true);
    }

    handleRowClickItem = (event: any, cName: string, cId: string, itemId: string) => {
        event.itemId = itemId;
        event.name = cName;
        event.customerId = cId;
        if (cName !== this.state.rowHighlightIndex) {
            this.setState({
                rowHighlightIndex: cName
            });
        }
        if (this.state.rowHighlightDivIndex == event.itemId) {
            this.setState({
                rowHighlightDivIndex: null,
            });
        }
        else {
            this.setState({
                rowHighlightDivIndex: event.itemId,
            });
        }
        this.props.handleRowClick(event);
    }

    handleChangePage = (event: any, newPage: any) => {
        this.setState({
            PageNumber: newPage,
        });

        this.props.handlePaginationAPI(this.state.pageSize, newPage);
    }

    handleChangeInputValue = (value: any, event: any) => {
        if (/^0/.test(value)) {
            value = value.replace(/^0/, "");
        }

        this.setState({
            pageSizeValue: value,
        })

        if (this.debounceTimeOutId) {
            clearTimeout(this.debounceTimeOutId);
        }
        this.debounceTimeOutId = setTimeout(() => {
            this.setState({
                pageSize: value,
            });
            this.props.handlePaginationAPI(value === "" ? this.defaultPageSize : value, 1);
        }, 1000);

    }

    setOrderForSorting = (order: any, orderBy: any) => {
        this.setState({
            order,
            orderBy
        });

        this.props.setPayloadVariables(order, orderBy, this.state.pageSize, this.state.PageNumber);

    }

    // validateNumbers = (e: any) => {
    //     return e.target.value = e.target.value.replace(/[^0-9\.]/g, '').replace(/(\..*)\./g, '$1');
    // }
    validateNumbers = (e: any) => {
        return (e.target.value = e.target.value
            .replace(/[^\d.]/g, ''));
        // .replace(/^\d*\.?\d*$/, "$1"));
    };

    handleDecimalsOnValue(value: any) {
        const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/g;
        return value.match(regex).join('');
    }

    updatePrice = (selectedRow: any, highlightedItemId: number, exec: any, current: number) => {
        this.props.handlePriceChange(exec, current, selectedRow, highlightedItemId,);
    }

    render(): React.ReactNode {
        const { data, powerBiSelectedCustomer, divisionFilter, handleRecReject,
            selectedCustomerData, totalPages, recommendationAction, handleRecAccept } = this.props;
        const { expandedRows, rowHighlightIndex, rowHighlightDivIndex, divExpandedRows } = this.state;

        if (powerBiSelectedCustomer) {
            if (data && data.list && this.isFirstTime) {
                data.list.forEach((d: any, index: number) => {
                    if (d.id === powerBiSelectedCustomer) {
                        setTimeout(() => {
                            const scrollingId: any = document.getElementById(`pricing_${d.id}`)
                            try {
                                scrollingId.scrollIntoView(false, {
                                    behaviour: "smooth"
                                });
                            } catch (e) {
                                console.log(e)
                            }
                        }, 2000);

                        this.handleExpansion(d.id);
                        this.handleRowClickLocal(d, 0);
                    }
                });
                this.isFirstTime = false;
            }
        }

        let hCol = Object.assign({}, this.columnStyle);
        hCol.backgroundColor = "#383838";
        return <>
            <Row style={{ height: "90%" }} className="show-grid">
                <Col className="leftTable" style={{ height: "100%" }} xs={24} sm={24} md={24}>
                    <table className="fixed_header crossSell">
                        <tbody className="tbodyClass" style={{ fontSize: this.fontSize }}>

                            <tr style={{ cursor: "pointer", position: "sticky" }}>
                                {headCells?.map((headCell: any) =>
                                    ((headCell.id === "itemid" && expandedRows.length) || ((headCell.id === "itemdesc" ||headCell.id === "peerPrice" || headCell.id === "currentPrice" || headCell.id === "adjustedPrice") && divExpandedRows.length) || headCell.id  === "customerDesc" ||
                                        headCell.id === "division" || headCell.id === "quantity" || headCell.id === "revenue"
                                        || headCell.id === "opportunity" || headCell.id === "action") ?
                                        (<Sorting orderBy={this.state.orderBy} order={this.state.order} headCell={headCell} setOrderForSorting={this.setOrderForSorting} rowSpan={1} />)
                                        : ('')
                                )}
                            </tr>


                            {data && data.list && data?.totalOpp !== 0 && data.list.map((d: any, pIndex: number) => {

                                return <>
                                    <tr key={`pricing_${d.id}`} id={`pricing_${d.id}`} className={(rowHighlightIndex !== null && rowHighlightIndex !== d.name && selectedCustomerData !== null) ? "dim curPointer" : "curPointer"}>
                                        {/* <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}>{d.id}</td> */}
                                        <td style={this.columnStyle} onClick={() => this.handleExpansion(d.name)}>
                                            <label className="rowClickIcon curPointer">
                                                {expandedRows == d.name ?
                                                //  <i className="fa">&#xf056;</i>
                                                <MinusRoundIcon/>
                                                  :
                                                //   <i className="fa">&#xf055;</i>
                                                <PlusRoundIcon/>
                                                }</label>
                                            <label onClick={() => this.handleRowClickLocal(d, pIndex)} className="curPointer" >{d.name}</label></td>
                                        {/*  <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}>{d.Customer_Class}</td> */}
                                        <td style={this.columnStyle} className="alignCenter">Total: {d.divisionList.length.toString()}</td>
                                        {expandedRows !== null && expandedRows.length ? <>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                            {/*  <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td> */}
                                        </> : ""}

                                        {divExpandedRows !== null && divExpandedRows.length ? <>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                        </> : ""}
                                        <td  className="alignCenter" style={this.columnStyle}>{numberFormatter(Number(d.total.quantity))}</td>

                                        <td  className="alignCenter" style={this.columnStyle}>${numberFormatter(Number(d.total.revenue), 2)}</td>

                                        {divExpandedRows !== null && divExpandedRows.length ? <>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                            <td onClick={() => this.handleRowClickLocal(d, pIndex)} style={this.columnStyle}></td>
                                        </> : ""}

                                        <td  className="alignCenter" style={this.columnStyle}>${numberFormatter(Number(d.total.opportunity), 2)}</td>

                                        <td className="alignCenter cursorPointer" style={this.columnStyle}>
                                            <button disabled={recommendationAction[d.name]?.isAll ? true : false} onClick={() => d.allDivisionAgreed ? handleRecAccept({ data: d }, 2) : handleRecReject({ data: d }, 2)} style={{ width: "3.2vw", fontSize: "0.55vw", marginRight: "1px" }}
                                                className={d.allDivisionAgreed ? "buttonMargin acceptAll" : "greyNackground"}>Accept All</button>
                                        </td>
                                    </tr>
                                    {expandedRows == d.name ? d.divisionList.map((d1: any, index: number) => {
                                        let hCol = Object.assign({}, this.columnStyle);
                                        hCol.backgroundColor = "#383838";
                                        return <>
                                            <tr style={{ backgroundColor: "#383838" }} className={((divisionFilter.length && divisionFilter[0] != d1.id && rowHighlightIndex == d.name)) ? "dim" : ""}>
                                                <td className={(rowHighlightIndex !== null && rowHighlightIndex !== d.id) ? "dim" : ""} style={hCol}></td>
                                                {/* <td className={(rowHighlightIndex !== null && rowHighlightIndex !== d.id) ? "dim" : ""} style={hCol}></td> */}
                                                {/* <td className={(rowHighlightIndex !== null && rowHighlightIndex !== d.name) ? "dim" : ""} style={hCol}></td> */}
                                                <td className="alignLeft curPointer flexx" style={hCol}>
                                                    <label className="rowClickIcon curPointer" onClick={() => this.handleDivExpansion(d1.id, d.name)}>
                                                        {divExpandedRows.includes(d.name + "_" + d1.id) ? 
                                                        // <i className="fa">&#xf056;</i> 
                                                        <MinusRoundIcon/>
                                                        : 
                                                        // <i className="fa">&#xf055;</i>
                                                        <PlusRoundIcon/>
                                                        }</label>
                                                    <label onClick={() => this.handleRowClickDiv(d1, d.name, d.id, true)} className="curPointer" >{d1.id}</label>
                                                </td>
                                                {expandedRows !== null && expandedRows.length ? <>
                                                    <td onClick={($event) => this.handleRowClickDiv(d1, d.name, d.id)} className="alignCenter curPointer" style={hCol}>Total: {d1.list.length}</td>
                                                    {/* <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td> */}
                                                </> : ""}
                                                {divExpandedRows !== null && divExpandedRows.length ? <>
                                                    {/* <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}>Total: {d1.list.length}</td> */}
                                                    {/* <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td> */}
                                                    {/* <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td> */}
                                                    <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td>
                                                </> : ""}
                                                {/* <td onClick={() => this.handleRowClickDiv(d1,item d.name, d.id)} className="alignRight curPointer" style={hCol}>PriceLine ID:</td> */}
                                                <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignCenter curPointer" style={hCol}>{numberFormatter(Number(d1.total.quantity))}</td>
                                                <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="curPointer alignCenter" style={hCol}>${numberFormatter(Number(d1.total.revenue))}</td>
                                                {divExpandedRows !== null && divExpandedRows.length ? <>
                                                    {/* <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}>Total: {d1.list.length}</td> */}
                                                    <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td>
                                                    <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td>
                                                    <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="alignRight curPointer" style={hCol}></td>
                                                </> : ""}
                                                <td onClick={() => this.handleRowClickDiv(d1, d.name, d.id)} className="curPointer alignCenter" style={hCol}>${numberFormatter(Number(d1.total.opportunity), 2)}</td>
                                                <td className="alignCenter cursorPointer" style={hCol}>
                                                    {/* <i style={d1?.allAggreed ?
                                                        { background: "green" } : { background: "grey" }}
                                                        className="fa fa-check acceptIcon"
                                                        onClick={() => d1?.allAggreed ? handleRecAccept({ data: d1.list, division: d1.id }, 1) : handleRecReject({ data: d1.list, division: d1.id }, 1)}
                                                        // onClick={() => handleRecAccept({ custId: d.id, divisionId: d1.id })}
                                                        aria-hidden="true"></i> */}
                                                    <CheckBoxIcon sx={{ color: `${(d1?.allAggreed)?'green':'gray'}`, cursor:'pointer' }} 
                                                     onClick={() => d1?.allAggreed ? handleRecAccept({ data: d1.list, division: d1.id }, 1) : handleRecReject({ data: d1.list, division: d1.id }, 1)}
                                                    />
                                                </td>
                                            </tr>

                                            {divExpandedRows.includes(d.name + "_" + d1.id) ? d1.list.map((d2: any, index: number) => {
                                                let hCol = Object.assign({}, this.columnStyle);
                                                hCol.backgroundColor = "#383838";
                                                return <>
                                                    <tr  style={{ backgroundColor: "#383838" }} className={(divisionFilter.length && divisionFilter[0] != d1.id) ? "" : ""}>
                                                        <td style={hCol}></td>
                                                        <td style={hCol}></td>
                                                        {/*  <td style={hCol}></td>
                                                        <td style={hCol}></td> */}
                                                        <td  onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>{d2.itemId}</td>
                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>{d2.Description}</td>
                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>{numberFormatter(Number(d2.quantity))}</td>
                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>${numberFormatter(Number(d2.revenue))}</td>

                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>${numberFormatter(Number(d2.Avg_peer_Price), 2)}</td>
                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>${numberFormatter(Number(d2.followingPrice), 2)}</td>
                                                        {/* <td className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignRight" : "curPointer alignRight"}
                                                            style={hCol}>${numberFormatter(Number(d2.adjustedPrice))}</td> */}
                                                        <td onClick={($event) => {
                                                            $event.stopPropagation();
                                                        }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"} style={hCol}>
                                                            <span style={{ color: 'white' }}>$&nbsp;</span>
                                                            <input type="text"
                                                                onInput={(e) => this.validateNumbers(e)}
                                                                key={d2.itemId}
                                                                style={{ background: 'grey', border: 'none', borderRadius: '4px', color: '#ffffff', textAlign: "center", width: '70%' }}
                                                                onClick={(e) => { e.stopPropagation() }} onChange={(e) => {
                                                                    this.updatePrice(d2, rowHighlightDivIndex, e.target.value, Number(d2.followingPrice))

                                                                }} className="inputBox"
                                                                value={d2.adjustedPrice}
                                                            />
                                                        </td>


                                                        <td onClick={(e) => { this.handleRowClickItem(d2, d.name, d.id, d2.itemId) }} className={(rowHighlightDivIndex !== null && rowHighlightDivIndex !== d2.itemId) ? "dim curPointer alignCenter" : "curPointer alignCenter"}
                                                            style={hCol}>${numberFormatter(Number(d2.opportunity), 2)}</td>

                                                        <td className="alignCenter cursorPointer" style={hCol}>
                                                            {/* <i style={(d2.isAgreed == 1 && (d2?.adjustedPrice == d2?.copyAdjustedPrice)) ?
                                                                { background: "grey" } : { background: "green" }}
                                                                className="fa fa-check acceptIcon"
                                                                // onClick={() => handleRecAccept({ custId: d.id, itemId: d2.itemId })}
                                                                // onClick={(e) => {e.stopPropagation();
                                                                //     d2.isAgreed==0?handleRecAccept({ itemId:d2.itemId,customerId:d2.bill_customer_id,division:d1.id,executedPrice:d2.adjustedPrice,peerPrice:d2.Avg_peer_Price,opportunity:d2.opportunity,isAgreed:d2.isAgreed,copyAdjustedPrice:d2.copyAdjustedPrice},0)
                                                                //     :(d2.isAgreed==1&&(d2?.adjustedPrice!==d2?.copyAdjustedPrice)?handleRecAccept({ itemId:d2.itemId,customerId:d2.bill_customer_id,division:d1.id,executedPrice:d2.adjustedPrice,peerPrice:d2.Avg_peer_Price,opportunity:d2.opportunity,isAgreed:d2.isAgreed,copyAdjustedPrice:d2.copyAdjustedPrice},0):'')
                                                                // }}
                                                                onClick={() => d2?.isAgreed ? handleRecReject({ itemId: d2.itemId, customerId: d2.bill_customer_id, division: d1.id, executedPrice: d2.adjustedPrice, peerPrice: d2.Avg_peer_Price, opportunity: d2.opportunity, isAgreed: d2.isAgreed, copyAdjustedPrice: d2.copyAdjustedPrice, project_flag: d2?.project_flag, peerGroupName: d2?.peerGroupName }, 0)
                                                                    : handleRecAccept({ itemId: d2.itemId, customerId: d2.bill_customer_id, division: d1.id, executedPrice: d2.adjustedPrice, peerPrice: d2.Avg_peer_Price, opportunity: d2.opportunity, isAgreed: d2.isAgreed, copyAdjustedPrice: d2.copyAdjustedPrice, project_flag: d2?.project_flag, peerGroupName: d2?.peerGroupName }, 0)}

                                                                aria-hidden="true"></i> */}
                                                            <CheckBoxIcon sx={{ color: `${(d2.isAgreed == 1 && (d2?.adjustedPrice == d2?.copyAdjustedPrice))?'gray':'green'}`, cursor:'pointer' }} 
                                                             onClick={() => d2?.isAgreed ? handleRecReject({ itemId: d2.itemId, customerId: d2.bill_customer_id, division: d1.id, executedPrice: d2.adjustedPrice, peerPrice: d2.Avg_peer_Price, opportunity: d2.opportunity, isAgreed: d2.isAgreed, copyAdjustedPrice: d2.copyAdjustedPrice, project_flag: d2?.project_flag, peerGroupName: d2?.peerGroupName }, 0)
                                                             : handleRecAccept({ itemId: d2.itemId, customerId: d2.bill_customer_id, division: d1.id, executedPrice: d2.adjustedPrice, peerPrice: d2.Avg_peer_Price, opportunity: d2.opportunity, isAgreed: d2.isAgreed, copyAdjustedPrice: d2.copyAdjustedPrice, project_flag: d2?.project_flag, peerGroupName: d2?.peerGroupName }, 0)}
                                                            />
                                                            {/* <i className="fa fa-edit editIcon"></i> */}
                                                        </td>
                                                    </tr>
                                                </>
                                            }) : ""}
                                        </>
                                    }) : ""}
                                </>
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row>
            {data && data?.list && data?.totalOpp !== 0 && <Row style={{ height: "10%" }} className="show-grid">
                <Col xs={24} sm={24} md={4} />
                <Col xs={24} sm={24} md={14}>
                    <Pagination totalPages={totalPages} handleChangePage={this.handleChangePage} pageSize={this.state.pageSize === "" ? this.defaultPageSize : this.state.pageSize} pageNumber={this.state.PageNumber} />
                </Col>
                <Col xs={24} sm={24} md={6}>
                    <label style={{ color: 'white', width: '50%' }}>
                        Rows per page:
                    </label>
                    <InputNumber value={this.state.pageSizeValue} onChange={this.handleChangeInputValue} style={{ width: '40%', padding: '1%', float: 'right' }} />
                </Col>

            </Row>}
            {/* <Row style={{ height: "10%" }} className="show-grid">
                <Col style={{ color: "white" }} xs={24} sm={24} md={17}>
                    <Row>
                        <label style={{ color: "#A4F504" }}>Actions: </label><i style={{ padding: "0.4%", marginRight: 0 }} className="fa fa-check acceptIcon" aria-hidden="true"></i> - Accept
                        
                    </Row>
                </Col>
                <Col xs={24} sm={24} md={2} />
                <Col xs={24} sm={24} md={1} />
            </Row> */}

        </>
    }
}